<template>
    <div class="loginBox">
        <div class="login_bg"></div>
        <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="0" class="login_form">
            <h1 class="logo">
                中怡新材后台管理
            </h1>
            <el-form-item prop="name">
                <el-input v-model="loginForm.name" clearable auto-complete='off' placeholder='请输入账号' @keyup.13.native='login("loginForm")'>
                    <i slot="prefix" class="iconfont icon-user"></i>
                </el-input>
            </el-form-item>
            <el-form-item prop="password">
                <el-input type='password' v-model="loginForm.password" clearable auto-complete='off' placeholder='请输入密码' @keyup.13.native='login("loginForm")'>
                    <i slot="prefix" class="iconfont icon-mima"></i>
                </el-input>
            </el-form-item>
            <el-button class='login_btn' type="primary" @click='login("loginForm")'>登 录</el-button>
            <p class="msg">Copyright@2025<span v-if="curYear != 2025">-{{curYear}}</span> 漳州中怡新材料科技有限公司</p>
        </el-form>
    </div>
</template>
<script>
    import { mapMutations } from 'vuex';
    import { ajax_login } from '@/utils/getData';
    import { setStore } from '@/utils/';

    export default{
        name:'login',
        data(){
            return{
                loginForm:{
                    name:'',
                    password:''
                },
                rules: {
                    name: [
                        { required: true, message: '请输入账号', trigger: 'blur' }
                    ],
                    password: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ]
                },
                loginBtnStatus:false,//登录按钮是否可点击
                curYear:''
            }
        },
        mounted(){
            let nowDate = new Date();
            this.curYear = nowDate.getFullYear();
        },
        methods:{
            ...mapMutations([
                'SETMEMBER'
            ]),
            login(formName){
                if(this.loginBtnStatus){
                    return false;
                }
                let that = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loginBtnStatus = true;
                        ajax_login(this.loginForm.name,this.loginForm.password).then(res=>{
                            this.loginBtnStatus = false;
                            if(res.code == 0){
                                if(!res.data.menus || res.data.menus.length == 0){
                                    this.$message({
                                        showClose:true,
                                        message: "请先联系管理员给当前账户分配权限再登录系统",
                                        type: 'error'
                                    });
                                    return false;
                                }
                                //设置当前登录账户相关信息
                                setStore("member",res.data);
                                this.SETMEMBER(res.data);
                                that.$router.push('/dashboard');
                            }else{
                                this.$message({
                                    showClose:true,
                                    message: res.message,
                                    type: 'error'
                                });
                            }
                        })
                    }
                });
            }
        }
    }
</script>
<style scoped>
    .loginBox{height:100%;position: relative;background: #f1f1f1;}
    .login_bg{width:100%;height:50%;position: absolute;left: 0;top: 0;background: url(../../assets/login.jpg) center top no-repeat #f1f1f1;}
    .login_form{width:380px;position: absolute;left: 50%;transform: translate(-50%,-50%);top:50%;text-align: center;background:#fff;padding: 50px 100px 40px;}
    .login_form .logo{margin-bottom:30px;}
    .login_form i{font-size:20px;vertical-align:middle;width: 36px;}
    .login_btn{width: 100%;margin-top:20px;font-size:16px;}
    .login_form .msg{color:#666;font-size:14px;margin-top:20px;line-height:24px;}
</style>